import { useMemo } from "react";

export function useIsDevelopment(): boolean {
    const isDevDomain = useMemo(() => {
        if (typeof window === "undefined") return false;

        const { host } = window.location;
        const parts = host.split(".");
        return parts.includes("dev"); // dev 포함 여부
    }, []);

    return isDevDomain;
}
